import {
  WithStyles,
  Theme,
  createStyles,
  withStyles,
  Avatar,
  Badge,
  IconButton,
  Grid,
  Tooltip,
  SvgIcon,
} from "@material-ui/core";
import * as React from "react";
import TextInputParentComponent from "./TextInputParentComponent";
import CheckIcon from "@material-ui/icons/Check";
import CrossIcon from "@material-ui/icons/Close";
import YESMoodGoodIcon from "@material-ui/icons/Mood";
import NOMoodBadIcon from "@material-ui/icons/MoodBad";
import ThumbsUpIcon from "@material-ui/icons/ThumbUp";
import ThumbsDownIcon from "@material-ui/icons/ThumbDown";
function RightFingerIcon(props: any) {
  return (
    <SvgIcon viewBox="0 0 512 512" {...props}>
      <g>
        <g>
          <path
            fill={props.fillcolor}
            d="M48,175.999H16c-8.832,0-16,6.368-16,14.24v227.552c0,7.84,7.168,14.208,16,14.208h32c8.832,0,16-6.368,16-14.24V190.207
			C64,182.367,56.832,175.999,48,175.999z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill={props.fillcolor}
            d="M480,175.999H242.88l48.96-38.944c14.08-10.88,16.32-31.04,5.12-44.8c-10.88-14.08-31.04-16.352-44.8-5.12L96,196.767
			v213.056c11.744,13.44,28.832,22.176,48,22.176h160c17.6,0,32-14.4,32-32c0-17.6-14.4-32-32-32h16c17.664,0,32-14.336,32-32
			s-14.336-32-32-32h16c17.664,0,32-14.336,32-32s-14.336-32-32-32h144c17.6,0,32-14.4,32-32C512,190.399,497.6,175.999,480,175.999
			z"
          />
        </g>
      </g>
    </SvgIcon>
  );
}
const styles = (theme: Theme) =>
  createStyles({
    root: {
      height: "100%",
      padding: 3,
    },
    button: {
      margin: theme.spacing(1),
      width: "30%",
      height: 48,
    },
    paper: {
      padding: theme.spacing(1) * 2,
      textAlign: "center",
      height: "100%",
      color: theme.palette.text.secondary,
    },
    control: {
      padding: theme.spacing(1) * 2,
    },
  });
interface Props extends WithStyles<typeof styles> {
  handleInputColorSelected: any;
  title: any;
  selectedIcon: any;
  selectedColor: any;
  iconScheme?: any;
}
class ColorPickerComponent extends React.Component<Props> {
  state = {
    indexSelected: -1,
    icons: Array<any>(),
  };

  componentDidMount = () => {
    this.populateDefault();
  };

  componentDidUpdate = (prevProps: any, prevState: any) => {
    if (prevProps.selectedColor !== this.props.selectedColor) {
      this.populateDefault();
    }
  };

  populateDefault = () => {
    let buildIcons = [
      {
        icon: (
          <CheckIcon style={{ margin: 5, color: "white" }} fontSize={"small"} />
        ),
        name: "Check",
      },
      {
        icon: (
          <CrossIcon style={{ margin: 5, color: "white" }} fontSize={"small"} />
        ),
        name: "Cross",
      },
      {
        icon: (
          <YESMoodGoodIcon
            style={{ margin: 5, color: "white" }}
            fontSize={"small"}
          />
        ),
        name: "YES",
      },
      {
        icon: (
          <NOMoodBadIcon
            style={{ margin: 5, color: "white" }}
            fontSize={"small"}
          />
        ),
        name: "NO",
      },
      {
        icon: (
          <ThumbsUpIcon
            style={{ margin: 5, color: "white" }}
            fontSize={"small"}
          />
        ),
        name: "ThumbUp",
      },
      {
        icon: (
          <ThumbsDownIcon
            style={{ margin: 5, color: "white" }}
            fontSize={"small"}
          />
        ),
        name: "ThumbDown",
      },
      {
        icon: (
          <RightFingerIcon
            style={{ margin: 5, color: "white" }}
            fontSize={"small"}
          />
        ),
        name: "RightFinger",
      },
    ];
    let icons = this.props.iconScheme ? this.props.iconScheme : buildIcons;
    this.setState(
      {
        icons: icons,
        indexSelected: -1,
      },
      () => {
        icons.map((colorObj: any, index: any) => {
          if (colorObj.name === this.props.selectedIcon) {
            this.setState({ indexSelected: index });
          }
          return null;
        });
      }
    );
  };
  render() {
    let { selectedColor } = this.props;
    return (
      <div style={{ marginTop: 10, marginBottom: 10 }}>
        <TextInputParentComponent label={this.props.title}>
          <Grid container justify={"flex-start"}>
            {this.state.icons.map((item: any, index: any) => {
              return (
                <IconButton
                  key={index.toString()}
                  onClick={() => {
                    this.setState(
                      {
                        indexSelected: index,
                      },
                      () => {
                        this.props.handleInputColorSelected(item.name, index);
                      }
                    );
                  }}
                >
                  <Tooltip title={""}>
                    <Badge
                      variant="dot"
                      invisible={
                        this.state.indexSelected === index ? false : true
                      }
                      color="secondary"
                    >
                      <Avatar
                        style={{
                          backgroundColor:
                            this.state.indexSelected === index
                              ? selectedColor
                                ? selectedColor
                                : ""
                              : "",
                          width: this.state.indexSelected === index ? 35 : 30,
                          height: this.state.indexSelected === index ? 35 : 30,
                        }}
                      >
                        {item.icon}
                      </Avatar>
                    </Badge>
                  </Tooltip>
                </IconButton>
              );
            })}
          </Grid>
        </TextInputParentComponent>
      </div>
    );
  }
}
export default withStyles(styles)(ColorPickerComponent);
